<template>
  <div class="dataBaseContent_wrapper" :style="wraperStyle">
    <div class="content_nav-wrapper">
      <span
        @click="activeIndex = 0"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 0 }"
        >功率曲线</span
      >
      <span
        @click="activeIndex = 1"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 1 }"
        >机型参数</span
      >
    </div>
    <div
      class="content"
      v-if="isExitTurbine || isCompare"
      :style="contentStyle"
    >
      <!-- 对比功率曲线类型切换 -->
      <div class="select-curve" v-if="showTop">
        <el-radio-group v-model="compareSelectType">
          <el-radio-button label="功率曲线"></el-radio-button>
          <el-radio-button label="推力系数"></el-radio-button>
        </el-radio-group>
      </div>
      <powerCurve
        v-if="activeIndex == 0"
        :comparePowerCurveType="comparePowerCurveType"
        :activeIndex="activeIndex"
      ></powerCurve>
      <techParameters
        v-if="activeIndex == 1"
        @tableHeight="tableHeight"
      ></techParameters>
    </div>
    <!-- 无机型库时展示无数据 -->
    <div class="empty" v-if="!isExitTurbine && !isCompare">
      <div class="empty-text">暂无数据</div>
    </div>
    <div class="upload">
      <upload></upload>
    </div>
  </div>
</template>

<script>
import powerCurve from './power-curve';
import techParameters from './tech-parameters';
import upload from './uploader';
import { mapState } from 'vuex';
export default {
  components: {
    powerCurve,
    techParameters,
    upload
  },
  data() {
    return {
      activeIndex: 0,
      compareSelectType: '功率曲线',
      contentStyle: {
        padding: '20px 10px'
      },
      wraperStyle: {
        height: 'auto'
      }
    };
  },
  computed: {
    ...mapState('model', ['isCompare', 'currentTurbine', 'turType']),
    comparePowerCurveType() {
      if (this.compareSelectType === '功率曲线') {
        return 3;
      } else {
        return 4;
      }
    },
    isExitTurbine() {
      if (Object.keys(this.currentTurbine).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    showTop() {
      if (this.activeIndex == 0 && this.isCompare) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isCompare(val) {
      if (val && this.activeIndex === 0) {
        this.contentStyle = {
          padding: '70px 10px 20px 10px'
        };
      } else {
        this.$nextTick(() => {
          this.contentStyle = {
            padding: '20px 10px'
          };
        });
      }
    },
    activeIndex(val) {
      if (val == 1) {
        this.contentStyle = {
          padding: '20px 10px'
        };
        this.wraperStyle = {
          height: 'calc(100% - 60px)'
        };
      } else {
        if (Object.keys(this.currentTurbine).length > 0) {
          this.wraperStyle = {
            height: 'auto'
          };
        } else {
          // 非对比无数据的时候展示
          this.wraperStyle = {
            height: 'calc(100% - 60px)'
          };
        }
        if (this.isCompare) {
          this.contentStyle = {
            padding: '70px 10px 20px 10px'
          };
        }
      }
    },
    turType(val) {
      if (val == '0') {
        if (Object.keys(this.currentTurbine).length > 0) {
          this.wraperStyle = {
            height: 'auto'
          };
        } else {
          // 非对比无数据的时候展示
          this.wraperStyle = {
            height: 'calc(100% - 60px)'
          };
        }
      } else {
        this.wraperStyle = {
          height: 'calc(100% - 60px)'
        };
      }
    }
  },
  methods: {
    tableHeight(val) {
      console.log(val);
    },
    handleClick() {}
  }
};
</script>

<style lang="less" scoped>
.dataBaseContent_wrapper {
  padding-bottom: 30px;
  position: relative;
  min-height: calc(100% - 60px);
  .content {
    background: #f1f6fa;
    box-shadow: 1px 3px 5px 0 rgba(4, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
    //min-height: calc(100vh - 180px);
    // height: 100%;
    .select-curve {
      position: absolute;
      left: 20px;
      top: 20px;
      cursor: pointer;
    }
  }
  .empty {
    background: #f1f6fa;
    box-shadow: 1px 3px 5px 0 rgba(4, 0, 0, 0.1);
    min-height: calc(100% - 30px);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 14px;
    color: #8f9197;
    height: 100%;
  }
  .upload {
    position: absolute;
    right: 0;
    top: -10px;
    width: 116px;
    height: 30px;
    background: linear-gradient(0deg, rgba(162, 204, 234, 0.16));
    border: 1px solid rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    cursor: pointer;
  }
}
.content_nav:before {
  height: 0 !important;
}
</style>
